import { combineReducers, createStore } from 'redux';

import reducers from './commonReducers';

const store = createStore(combineReducers(reducers));

export default store;
